export const CREATE_CENSUS_COOLER = 'CREATE_CENSUS_COOLER'